export const TESTIMONIALS_STEP = 12;

/**
 * Parses a ?show= query value into the number of testimonials to display.
 * Rounds up to a whole step so only a handful of URL variants exist.
 * Returns null when the value is present but not a valid count.
 */
export const parseVisibleCount = (value, step = TESTIMONIALS_STEP) => {
    if (value === undefined) return step;
    if (typeof value !== 'string' || !/^[1-9]\d{0,5}$/.test(value)) return null;
    return Math.ceil(Number(value) / step) * step;
};

/**
 * Returns the first `visible` testimonials plus load-more metadata.
 * Returns null when `visible` is beyond the last step, so unbounded
 * ?show= values cannot generate endless cacheable URLs.
 */
export const sliceTestimonials = (testimonials, visible, step = TESTIMONIALS_STEP) => {
    const total = testimonials.length;
    const lastStep = Math.max(step, Math.ceil(total / step) * step);
    if (visible > lastStep) return null;

    return {
        items: testimonials.slice(0, visible),
        visible,
        total,
        nextVisible: visible < total ? visible + step : null,
    };
};
